// extracted by mini-css-extract-plugin
export default {"export-data__wrapper":"Export_export-data__wrapper__kC5cP","export-data__wrapper-svg":"Export_export-data__wrapper-svg__qM9kW"};